import React from "react";
import PropTypes from "prop-types";
import notFoundGraphic from "components/Images/400-error.svg";
import { Link } from "react-router-dom";

const NoResults = ({ keyword }) => {
  return (
    <div className="error">
      <div className="error__container">
        <img
          className="error__image"
          src={notFoundGraphic}
          alt="simple illustration of a broken foot"
        />
        <div className="error__text">
          <h1>{`Sorry, we couldn't find '${keyword}'.`}</h1>
          <p>
            Check the spelling, try a more general term, or
            <Link to="/catalog" className="mx-1 d-inline-block">
              browse our catalog
            </Link>
            .
          </p>
          <p>
            Still can’t find what you’re looking for?
            <Link to="/contact-us" className="ms-1">
              Contact us
            </Link>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

NoResults.propTypes = {
  keyword: PropTypes.string.isRequired
};

export default NoResults;
